import { ColumnProps } from 'primereact/column';

export const getDataTable = (): ColumnProps[] => {
  return [
    {
      field: 'playa',
      header: 'Playa',
    },
    {
      field: 'armador',
      header: 'Armador',
    },
    {
      field: 'fechaCerrado',
      header: 'Fecha de Cierre',
    },
    {
      field: 'motivo',
      header: 'Motivo',
    },
    {
      field: 'precintos',
      header: 'Precintos',
    },
  ];
};

export const getLogsDataTable = (): ColumnProps[] => {
  return [
    {
      header: 'Usuario',
      field: 'usuario',
    },
    {
      header: 'Fecha',
      field: 'fecha',
    },
    {
      header: 'Detalle',
      field: 'detalle',
    },
  ];
};
